import { render, staticRenderFns } from "./CookShell.vue?vue&type=template&id=1a577fe4&"
import script from "./CookShell.vue?vue&type=script&lang=ts&"
export * from "./CookShell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports